import { isRealGatewayAccessToken } from './gatewayAuth';

export const LOCAL_DEV_CREDENTIALS = new Set([
  'ops@example.com:password123',
  'admin@admin.com:password',
  'admin:password',
  'user:password',
  'user@user.com:password',
]);

export type LoginFailureKind = 'http' | 'timeout' | 'network';

export function loginFailureKind(error: unknown, responseOk?: boolean): LoginFailureKind {
  if (error instanceof DOMException && error.name === 'AbortError') {
    return 'timeout';
  }
  if (error) {
    return 'network';
  }
  return responseOk === false ? 'http' : 'http';
}

/**
 * Local demo fallback is only for a down gateway. A timeout or HTTP error
 * means the gateway is there — do not wipe a JWT or mint `__legacy__`.
 */
export function shouldUseLocalDevFallback(options: {
  isLocalHost: boolean;
  email: string;
  password: string;
  failureKind: LoginFailureKind;
  existingToken?: string | null;
}): boolean {
  if (!options.isLocalHost) {
    return false;
  }
  if (isRealGatewayAccessToken(options.existingToken)) {
    return false;
  }
  if (options.failureKind !== 'network') {
    return false;
  }
  return LOCAL_DEV_CREDENTIALS.has(`${options.email}:${options.password}`);
}
